
export interface ReceiptGenerationContext {
  amount?: number;
  orderId: string;
  productName?: string;
  template?: string;
  userId?: string;
}
